export default __webpack_public_path__ + "static/media/74.7fb0b2fd.jpeg";